import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part11 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 5;
	chapterIds = {
		
		scenario4_5B_s19: 'CALM - Scenario 4 End - 5B - Start - 4B - Segment 19',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part11.id;
	}

	public start() {
		const context = this;
		context.segment1Step2Dialogue();
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		this.scenario.dialog(
			'CN-C04-L3-020b',
			[{
				text: 'Bring the form to Mr. Zolic to complete.',				
				scoreType: ScoreType.Zero,
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1MirandaResponds(), context.partIndx);
			}
		);
		context.scenario.updateObjective('');
	}

	private segment2Step1MirandaResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_5B_s19, () => {
			context.onDone();
		});
	}
}